import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { UpdateUserMutation, UserInput } from '#/graphql/types';
import { updateUser } from '#/graphql/mutations';
import { get, pick } from 'lodash';
import { GET_USER } from './useUserQuery';

const q = gql(updateUser);

const useUserUpdate = () => {
  const [mutation, result] = useMutation<UpdateUserMutation>(q);
  const updateUser = useCallback(
    async (itemId: string, user: UserInput) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(user, ['name', 'email', 'phone', 'role', 'address']),
        },
        refetchQueries: [{ query: GET_USER, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });
      return get(response, 'data.updateUser', undefined);
    },
    [mutation],
  );

  return { updateUser, result };
};
// Used in the modules Form file
export default useUserUpdate;
